// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__1AEw-","buttonSecondary":"button_buttonSecondary__30mKN"};